import React from 'react'
import borde from "./../../assets/img/borde.svg";

const Saludo = props => (
  <section className="section saludo">
    <div className="hero">
      <img className="borde" src={borde} alt="" />

      <div className="hero-body">
        <div className="container">
          <div className="columns">
            <div className="column is-8 is-offset-2">
              <p>{props.lang === "es" ? props.apiHome.texto_bienvenida : props.apiHome.texto_bienvenida}</p>
            </div>
          </div>
        </div>
      </div>

      <img className="borde" src={borde} alt="" />
    </div>
  </section>
);

export default Saludo;
